export default function ({ app, route, redirect }) {
	let language = app.i18n.locale;
	let currentRoute = route;

	if (language === 'sk' && (currentRoute.path === '/jak-soutezit' || currentRoute.path === '/ako-sutazit' || currentRoute.path === '/ceny' || currentRoute.path === '/iqos' || currentRoute.path === '/profil' || currentRoute.path === '/registrovat' || currentRoute.path === '/vloz-kod' || currentRoute.path === '/vyhercovia/' || currentRoute.path === '/vyherci/' || currentRoute.path === '/vloz-kod')) {
		return redirect('/');
	}
}
